import { Text } from 'components/texts'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'
import Requests from './Requests/Requests.js'
import { Container, Paper } from '@mui/material'
import { yupResolver } from '@hookform/resolvers/yup'
import { ChangesContext } from 'contexts/ChangesContext'
import { CreateHeader } from 'pages/logged/admin/components'
import React, { useContext, useRef, useEffect } from 'react'
import { SnackbarProvider, enqueueSnackbar } from 'notistack'
import { BreadcrumbsList, Line } from 'components/data_display'

//FORM
import Statics from 'objects/common/Statics'
import { DataFormResponsable } from 'components/forms/display'
import { validationSchema } from 'components/forms/display/responsable/DataForm/validation.js'


export default function CreateResponsable(){
  const { register, handleSubmit, formState: { errors, dirtyFields }, getValues } = useForm({ resolver: yupResolver(validationSchema) })
  const navigate = useNavigate()

  const headerRef = useRef()

  const { updateChanges } = useContext(ChangesContext)

  useEffect(() => {
    if (Object.keys(dirtyFields).length > 0)
      updateChanges(true)
  }, [Object.keys(dirtyFields).length])

  const createResponsable = () => {
    headerRef.current.button.setLoading(true)

    new Requests().createResponsable(getValues, async (res) => {
      headerRef.current.button.setLoading(false)
      enqueueSnackbar(<Text>Se ha creado el tutor correctamente. Redirigiendo a la pagina de edición..</Text>, { variant: "success" })
      updateChanges(false)

      await Statics.delay(1500).then(() => {navigate('./../' + res.responsable.id + "/editar")})
    }, (res) => {
      headerRef.current.button.setLoading(false)
      enqueueSnackbar(<Text>{res}</Text>, { variant: "error" })
    })
  }

  return (
    <Container maxWidth={false} sx={{ mt: 5 }}>
      <form className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
        <BreadcrumbsList breadcrumbsList={[
          { to: "/",      label: "Inicio" },
          { to: "./../",  label: "Tutores" },
          { to: "./",     label: "Crear tutor", actualItem: true },
        ]} />

        <Paper elevation={2} sx={{mx: 8, my: 2, pb: 5}}>
          <CreateHeader 
            ref          = {headerRef} 
            title        = {"Crear tutor"}
            handleSubmit = {handleSubmit(createResponsable)} />

          <Line className={"my-5"} />

          <DataFormResponsable register={register} errors={errors} />
        </Paper>

        <SnackbarProvider autoHideDuration={3000}/>
      </form>
    </Container>
  )
}